export enum WhatsappTemplateCategory {
  UTILITY = 'UTILITY',
  MARKETING = 'MARKETING',
}

